import { createReducer } from '@reduxjs/toolkit';

import downloadFile, { clearDownloadFile } from '../../thunks/general/downloadFile';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const downloadFileReducer = createReducer(initialState, {
  [downloadFile.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [downloadFile.fulfilled]: (state, { payload: data }) => ({
    ...state,
    data,
    loading: false,
  }),
  [clearDownloadFile]: () => initialState,
  [downloadFile.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default downloadFileReducer;
